<template>
    <form-modal
        name="edit-router-password"
        :primary-button-text="lang('Spara','Save')"
        primary-button-class="is-primary"
        :title="lang('Ändra router-lösenord','Change router password')"
        :action="route('front.my-pages.api.router-settings.update-router-password')"
        :callback="reloadPage"
        method="patch"
    >
        <div>
            <div class="flex mb-xl bg-neutral-lighter p-md">
                <a class="btn-help cursor-auto font-bold mr-md">
                    <span>!</span>
                </a>
                <p class="mb-0">
                    {{ lang(
                        'Detta lösenord använder du för att logga in på din routers gränssnitt. Minst 8 tecken.',
                        'This password is used to login to your router\'s admin interface. At least 8 characters.'
                    ) }}
                </p>
            </div>

            <text-input
                v-model="password"
                type="password"
                name="password"
                :label="lang('Lösenord','Password')"
                :validations="'required|min:8|max:32'"
            />

            <text-input
                v-model="password_confirmation"
                type="password"
                name="password_confirmation"
                :label="lang('Upprepa lösenord','Repeat password')"
                :validations="'required|min:8|max:32'"
            />
        </div>
    </form-modal>
</template>

<script>
    export default {
        data() {
            return {
                password: '',
                password_confirmation: '',
            };
        },
        methods: {
            reloadPage() {
                return window.location.reload();
            },
        },
    };
</script>
